import React, { FC } from 'react';
import styled from 'styled-components';

import BaseCard, { IBaseCard } from '@ui/atoms/BaseCard';

import theme from '@theme/FolxTheme';

interface IRoundedCardProps extends IBaseCard {}

const RoundCard = styled(BaseCard)`
	padding: ${theme.spacing.lg} ${theme.spacing.md} ${theme.spacing.lg} ${theme.spacing.md};
`;

const RoundedCard: FC<IRoundedCardProps> = (props) => {
	return <RoundCard {...props} borderless radius="xxxl" />;
};

export default styled(RoundedCard)``;
